module.exports = __webpack_public_path__ + "static/jobBg-ddbdde62a532fb673ccda66a30491d1b.jpg";